require('./bootstrap');

import LazyLoad from "vanilla-lazyload";
document.addEventListener(
    'DOMContentLoaded',
    function () {
        let myLazyLoad = new LazyLoad( {
            elements_selector: ".lazy-load"
        } );
    }
);

document.addEventListener('DOMContentLoaded', function () {
    // play video
    if (document.querySelector('.video__wrap')) {
        let video = document.querySelector('.video__wrap'),
            video_btn = document.querySelector('.video__btn'),
            video_src = video.dataset.src;
        if (video && video_btn) {
            video_btn.addEventListener('click', function () {
                video.classList.add('play');
                let video_frame = document.createElement('iframe');
                video_frame.classList.add('youtube-video');
                video_frame.setAttribute('src', video_src);
                video.appendChild(video_frame);
            })
        }
    }
});
